export const response15_1 = {
	"Payload": {
		"Match": {
			"ResponseNumber": 15,
			"Id": "tutorial",
			"Version": 1,
			"CreatorId": 22,
			"Type": "ch",
			"State": "pr",
			"BlockingType": "alternate",
			"PlayerCount": 2,
			"ActiveRoundNum": 3,
			"ActiveUserId": 22,
			"RoundCount": 3,
			"CreatedTime": 1582666798,
			"UpdatedTime": 1582666798,
			"InvitedTime": 0,
			"CompletedTime": 0,
			"CanAcceptChallenge": false,
			"IsStartHand": true,
			"CanRollDice": true,
			"CanApplyFreeroll": false,
			"CanApplyHandReset": false,
			"CanKeepHand": false,
			"CanResignMatch": true,
			"UserAcceptedTime": 1582666798,
			"UserResignedTime": 0,
			"UserCurrentRound": 3,
			"UserActiveTime": 1582666798,
			"UserNudgedTime": 0,
			"UserNudgeSentTime": 0,
			"UserFreeRolls": 0,
			"UserFreeRollsUsed": 0,
			"UserState": "pl",
			"UserBaseScore": 0,
			"UserFinalScore": 0,
			"UserOutcome": 0,
			"Opponents": [{
				"UserId": 92,
				"Username": "Ava",
				"DisplayName": "Ava",
				"ImageUrl": "",
				"AcceptedTime": 1582682127,
				"ResignedTime": 0,
				"CurrentRound": 4,
				"ActiveTime": 1582682187,
				"NudgedTime": 0,
				"NudgeSentTime": 0,
				"State": "pl",
				"TotalScore": 5,
				"Outcome": 0,
				"IsBot": true,
				"MatchRounds": [{
					"RoundNum": 1,
					"RetryLimit": 1,
					"RetryNum": 0,
					"State": "co",
					"Score": 1,
					"FinalScore": 2,
					"Outcome": 1,
					"FreeRollLimit": 1,
					"FreeRollsUsed": 0,
					"FinalDiceRoll": [4, 0, 3, 5, 3, 5, 1, 3, 4],
					"FinalDiceFaces": ["Ac", "Ah", "2d", "2s", "6s", "Qc", "7c", "Ad", "7d"],
					"BestHand": [1, 7, 8, 6],
					"BestHandFaces": ["Ah", "Ad", "7d", "7c"],
					"BestHandTarget": 3,
					"BestPossibleHand": false,
					"SectionBonus": 0,
					"Rolls": [{
						"RollNum": 1,
						"DiceRoll": [0, 0, 2, 3, 2, 3, 0, 5, 4],
						"DiceFaces": ["7s", "Ah", "Th", "4c", "9d", "6h", "Qs", "4h", "7d"],
						"Selection": [],
						"FreeRoll": false,
						"Completed": false,
						"BestHand": [0, 8, 7, 3],
						"BestHandFaces": ["7s", "7d", "4h", "4c"],
						"BestHandTarget": 3,
						"BestPossibleHand": false
					}, {
						"RollNum": 2,
						"DiceRoll": [3, 4, 4, 2, 0, 2, 1, 5, 5],
						"DiceFaces": ["5d", "6c", "8c", "Kd", "As", "8s", "7c", "4h", "2h"],
						"Selection": [],
						"FreeRoll": false,
						"Completed": false,
						"BestHand": [],
						"BestHandFaces": [],
						"BestHandTarget": 3,
						"BestPossibleHand": false
					}, {
						"RollNum": 3,
						"DiceRoll": [4, 0, 3, 2, 3, 5, 3, 3, 4],
						"DiceFaces": ["Ac", "Ah", "2d", "Kd", "6s", "Qc", "Kc", "Ad", "7d"],
						"Selection": [],
						"FreeRoll": false,
						"Completed": false,
						"BestHand": [0, 1, 3, 6],
						"BestHandFaces": ["Ac", "Ah", "Kd", "Kc"],
						"BestHandTarget": 3,
						"BestPossibleHand": true
					}]
				}, {
					"RoundNum": 2,
					"RetryLimit": 1,
					"RetryNum": 0,
					"State": "co",
					"Score": 2,
					"FinalScore": 0,
					"Outcome": 0,
					"FreeRollLimit": 1,
					"FreeRollsUsed": 0,
					"FinalDiceRoll": [0, 1, 1, 0, 0, 3, 0, 3, 5],
					"FinalDiceFaces": ["7s", "4s", "Qd", "Qh", "As", "6h", "Qs", "Ad", "2h"],
					"BestHand": [2, 3, 6],
					"BestHandFaces": ["Qd", "Qh", "Qs"],
					"BestHandTarget": 4,
					"BestPossibleHand": true,
					"SectionBonus": 0,
					"Rolls": [{
						"RollNum": 1,
						"DiceRoll": [2, 0, 4, 1, 4, 3, 3, 5, 0],
						"DiceFaces": ["Jd", "Ah", "8c", "Tc", "4d", "6h", "Kc", "4h", "Kh"],
						"Selection": [],
						"FreeRoll": false,
						"Completed": false,
						"BestHand": [],
						"BestHandFaces": [],
						"BestHandTarget": 4,
						"BestPossibleHand": false
					}, {
						"RollNum": 2,
						"DiceRoll": [2, 0, 4, 1, 4, 3, 3, 5, 0],
						"DiceFaces": ["Jd", "Ah", "8c", "Tc", "4d", "6h", "Kc", "4h", "Kh"],
						"Selection": [],
						"FreeRoll": false,
						"Completed": false,
						"BestHand": [],
						"BestHandFaces": [],
						"BestHandTarget": 4,
						"BestPossibleHand": false
					}, {
						"RollNum": 3,
						"DiceRoll": [0, 1, 1, 0, 0, 3, 0, 3, 5],
						"DiceFaces": ["7s", "4s", "Qd", "Qh", "As", "6h", "Qs", "Ad", "2h"],
						"Selection": [],
						"FreeRoll": false,
						"Completed": true,
						"BestHand": [2, 3, 6],
						"BestHandFaces": ["Qd", "Qh", "Qs"],
						"BestHandTarget": 4,
						"BestPossibleHand": false
					}]
				}, {
					"RoundNum": 3,
					"RetryLimit": 1,
					"RetryNum": 0,
					"State": "co",
					"Score": 0,
					"FinalScore": 0,
					"Outcome": 2,
					"FreeRollLimit": 1,
					"FreeRollsUsed": 0,
					"FinalDiceRoll": [3, 2, 0, 4, 2, 1, 5, 2, 0],
					"FinalDiceFaces": ["5d", "8d", "5h", "9s", "9d", "3d", "5s", "5c", "Kh"],
					"BestHand": [],
					"BestHandFaces": [],
					"BestHandTarget": 5,
					"BestPossibleHand": false,
					"SectionBonus": 0,
					"Rolls": [{
						"RollNum": 1,
						"DiceRoll": [0, 2, 0, 2, 1, 1, 5, 3, 1],
						"DiceFaces": ["7s", "8d", "5h", "Kd", "3c", "3d", "5s", "Ad", "Jc"],
						"Selection": [],
						"FreeRoll": false,
						"Completed": false,
						"BestHand": [],
						"BestHandFaces": [],
						"BestHandTarget": 5,
						"BestPossibleHand": false
					}, {
						"RollNum": 2,
						"DiceRoll": [3, 3, 1, 2, 3, 0, 0, 4, 5],
						"DiceFaces": ["5d", "Xj", "Qd", "Kd", "6s", "2c", "Qs", "3s", "2h"],
						"Selection": [],
						"FreeRoll": false,
						"Completed": false,
						"BestHand": [4, 0, 1, 7, 8],
						"BestHandFaces": ["6s", "5d", "Xj", "3s", "2h"],
						"BestHandTarget": 5,
						"BestPossibleHand": false
					}, {
						"RollNum": 3,
						"DiceRoll": [3, 2, 0, 4, 2, 1, 5, 2, 0],
						"DiceFaces": ["5d", "8d", "5h", "9s", "9d", "3d", "5s", "5c", "Kh"],
						"Selection": [],
						"FreeRoll": false,
						"Completed": false,
						"BestHand": [],
						"BestHandFaces": [],
						"BestHandTarget": 5,
						"BestPossibleHand": false
					}]
				}]
			}],
			"Rounds": [{
				"RoundNum": 1,
				"Rolls": 3,
				"State": "pl",
				"TargetHand": 3,
				"TargetHandPoints": 1000,
				"TargetHandBonusPoints": 1000,
				"WinnerTakeAll": false,
				"SectionBonus": 0,
				"SectionEnd": false
			}, {
				"RoundNum": 2,
				"Rolls": 3,
				"State": "ns",
				"TargetHand": 4,
				"TargetHandPoints": 1000,
				"TargetHandBonusPoints": 1000,
				"WinnerTakeAll": false,
				"SectionBonus": 0,
				"SectionEnd": false
			}, {
				"RoundNum": 3,
				"Rolls": 3,
				"State": "ns",
				"TargetHand": 5,
				"TargetHandPoints": 2500,
				"TargetHandBonusPoints": 2500,
				"WinnerTakeAll": false,
				"SectionBonus": 0,
				"SectionEnd": true
			}],
			"UserMatchRounds": [{
				"RoundNum": 1,
				"RetryLimit": 1,
				"RetryNum": 0,
				"State": "co",
				"Score": 1000,
				"FinalScore": 0,
				"Outcome": 0,
				"FreeRollLimit": 1,
				"FreeRollsUsed": 0,
				"FinalDiceRoll": [5, 1, 0, 0, 3, 5, 2, 5, 5],
				"FinalDiceFaces": ["9c", "4s", "5h", "Qh", "6s", "Qc", "9h", "4h", "2h"],
				"BestHand": [3, 5, 6, 0],
				"BestHandFaces": ["Qh", "Qc", "9h", "9c"],
				"BestHandTarget": 3,
				"BestPossibleHand": false,
				"SectionBonus": 0,
				"Rolls": [{
					"RollNum": 1,
					"DiceRoll": [2, 1, 0, 1, 1, 0, 1, 1, 1],
					"DiceFaces": ["Jd", "4s", "5h", "10c", "3c", "2c", "7c", "6d", "Jc"],
					"Selection": [],
					"FreeRoll": false,
					"Completed": false,
					"BestHand": [],
					"BestHandFaces": [],
					"BestHandTarget": 3,
					"BestPossibleHand": false
				}, {
					"RollNum": 2,
					"DiceRoll": [2, 3, 0, 1, 1, 0, 1, 1, 1],
					"DiceFaces": ["Jd", "Xj", "5h", "10c", "3c", "2c", "7c", "6d", "Jc"],
					"Selection": [0, 8],
					"FreeRoll": false,
					"Completed": false,
					"BestHand": [0,1,3,8],
					"BestHandFaces": ["Jd", "Xj", "10c", "Jc"],
					"BestHandTarget": 3,
					"BestPossibleHand": false
				}, {
					"RollNum": 3,
					"DiceRoll": [2, 3, 0, 1, 1, 0, 1, 3, 1],
					"DiceFaces": ["Jd", "Xj", "5h", "10c", "3c", "2c", "7c", "Ad", "Jc"],
					"Selection": [0, 1, 8],
					"FreeRoll": false,
					"Completed": false,
					"BestHand": [1,7,0,8],
					"BestHandFaces": ["Xj", "Ad", "Jd", "Jc"],
					"BestHandTarget": 3,
					"BestPossibleHand": false
				}]
			}, {
				"RoundNum": 2,
				"RetryLimit": 1,
				"RetryNum": 0,
				"State": "rc",
				"Score": 1000,
				"FinalScore": 2000,
				"Outcome": 0,
				"FreeRollLimit": 1,
				"FreeRollsUsed": 0,
				"FinalDiceRoll": [5, 0, 5, 2, 0, 2, 0, 3, 0],
				"FinalDiceFaces": ["9c", "Ah", "Ks", "Kd", "As", "8s", "Qs", "Ad", "Kh"],
				"BestHand": [1, 4, 7],
				"BestHandFaces": ["Ah", "As", "Ad"],
				"BestHandTarget": 4,
				"BestPossibleHand": true,
				"SectionBonus": 0,
				"Rolls": [{
					"RollNum": 1,
					"DiceRoll": [0, 1, 1, 5, 5, 0, 4, 1, 0],
					"DiceFaces": ["7s", "4s", "Qd", "2s", "Jh", "2c", "Td", "6d", "Kh"],
					"Selection": [],
					"FreeRoll": false,
					"Completed": false,
					"BestHand": [],
					"BestHandFaces": [],
					"BestHandTarget": 4,
					"BestPossibleHand": false
				}, {
					"RollNum": 2,
					"DiceRoll": [1, 0, 5, 5, 0, 0, 0, 1, 3],
					"DiceFaces": ["3h", "Ah", "Ks", "2s", "As", "2c", "Qs", "6d", "Ts"],
					"Selection": [3,5],
					"FreeRoll": false,
					"Completed": false,
					"BestHand": [],
					"BestHandFaces": [],
					"BestHandTarget": 4,
					"BestPossibleHand": false
				}, {
					"RollNum": 3,
					"DiceRoll": [5, 0, 5, 2, 0, 2, 0, 3, 0],
					"DiceFaces": ["9c", "Ah", "Ks", "Kd", "As", "8s", "Qs", "Ad", "Kh"],
					"Selection": [1,4],
					"FreeRoll": false,
					"Completed": false,
					"BestHand": [1, 4, 7],
					"BestHandFaces": ["Ah", "As", "Ad"],
					"BestHandTarget": 4,
					"BestPossibleHand": true
				}]
			}, {
				"RoundNum": 3,
				"RetryLimit": 1,
				"RetryNum": 0,
				"State": "co",
				"Score": 2500,
				"FinalScore": 5000,
				"Outcome": 1,
				"FreeRollLimit": 1,
				"FreeRollsUsed": 0,
				"DiceRoll": [5, 0, 1, 3, 3, 4, 3, 0, 2],
				"DiceFaces": ["9c", "Ah", "Qd", "4c", "6s", "Xj", "Kc", "Js", "8h"],
				"BestHand": [1, 6, 5, 7, 2],
				"BestHandFaces": [
					"Kc",
					"Qd",
					"Js",
					"Xj",
					"9c"
				],
				"BestHandTarget": 5,
				"BestPossibleHand": true,
				"SectionBonus": 0,
				"Rolls": [{
					"RollNum": 1,
					"DiceRoll": [5, 1, 1, 3, 3, 0, 4, 0, 2],
					"DiceFaces": ["9c", "4s", "Qd", "4c", "6s", "2c", "Td", "Js", "8h"],
					"Selection": [],
					"FreeRoll": false,
					"Completed": false,
					"BestHand": [1, 6, 2, 7, 5],
					"BestHandFaces": [
						"Kc",
						"Qd",
						"Js",
						"Xj",
						"9c"
					],
					"BestHandTarget": 5,
					"BestPossibleHand": false
				},{
					"RollNum": 2,
					"DiceRoll": [5, 0, 1, 2, 3, 0, 4, 0, 2],
					"DiceFaces": ["9c", "Ah", "Qd", "Kd", "6s", "2c", "Td", "Js", "8h"],
					"Selection": [3, 2, 7, 6, 0],
					"FreeRoll": false,
					"Completed": false,
					"BestHand": [1, 3, 2, 7, 6],
					"BestHandFaces": [
						"Kd",
						"Qd",
						"Js",
						"Td",
						"9c"
					],
					"BestHandTarget": 5,
					"BestPossibleHand": true
				}]
			}]
		}
	},
	"ErrorCode": 0,
	"ErrorMessage": ""
}
